/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planfreetickets2Inputs */

const en_planfreetickets2 = /** @type {(inputs: Planfreetickets2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tickets carry no fee on any plan.`)
};

const de_planfreetickets2 = /** @type {(inputs: Planfreetickets2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis-Tickets kosten in jedem Plan keine Gebühr.`)
};

/**
* | output |
* | --- |
* | "Free tickets carry no fee on any plan." |
*
* @param {Planfreetickets2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planfreetickets2 = /** @type {((inputs?: Planfreetickets2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planfreetickets2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planfreetickets2(inputs)
	return de_planfreetickets2(inputs)
});
export { planfreetickets2 as "planFreeTickets" }